module.exports = __webpack_public_path__ + "img/linkedin.7a00a2f3.svg";